import React from 'react';

interface ErrorIconProps {
  width?: string | number;
  height?: string | number;
  color?: string;
  className?: string;
}

const ErrorIcon: React.FC<ErrorIconProps> = ({
  width = '24',
  height = '24',
  color = '#EA543C',
  className,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 15C12.5523 15 13 14.5523 13 14V9.00001C13 8.44772 12.5523 8.00001 12 8.00001C11.4477 8.00001 11 8.44772 11 9.00001V14C11 14.5523 11.4477 15 12 15Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.6739 17.5049L12.8689 5.56395C12.4852 4.89079 11.5149 4.89079 11.1312 5.56395L4.32627 17.5049C3.94636 18.1716 4.42779 19 5.1951 19H18.8051C19.5724 19 20.0538 18.1716 19.6739 17.5049ZM14.6065 4.5737C13.4556 2.55421 10.5445 2.55421 9.3936 4.5737L2.58863 16.5147C1.44889 18.5146 2.89318 21 5.1951 21H18.8051C21.107 21 22.5513 18.5146 21.4115 16.5147L14.6065 4.5737Z"
        fill={color}
      />
      <path
        d="M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z"
        fill={color}
      />
    </svg>
  );
};

export default ErrorIcon;
